$('.featured-single-item').slick({
  fade: true,
  dots: true,
  arrows: false,
  autoplay: true,
});
